import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';

const SocialSharing = ({ event }) => {
  const getShareMessage = () => {
    if (event?.id === 'couples-conference') {
      return `Join us at the ${event.title}! ${event.tagline}. ${event.dates}. Register now:`;
    }
    if (event?.id === 'youth-conference') {
      return `Join us at the ${event.title}! "${event.tagline}". ${event.dates}. Don't miss this powerful two-day youth event! Register now:`;
    }
    return `Join me at the '${event?.tagline || 'Armed and Ready for the Kingdom'}' ${event?.title || 'Youth Summer Boot Camp 2025'}! It's going to be amazing! Register now:`;
  };
  
  const shareMessage = getShareMessage();
  
  const handleShare = (platform) => {
    // Use a consistent URL for sharing regardless of current page
    const url = window.location.origin;
    let shareUrl;
    
    switch(platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(shareMessage)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}&url=${encodeURIComponent(url)}`;
        break;
      case 'instagram':
        // Instagram doesn't have a direct share URL, but we can copy the message to clipboard
        navigator.clipboard.writeText(`${shareMessage} ${url}`);
        alert('Message copied! Open Instagram to share.');
        return;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(`${shareMessage} ${url}`)}`;
        break;
      default:
        return;
    }
    
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };
  
  return (
    <section className="py-5 bg-light" id="share">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <h2 className="fw-bold mb-4">Tell a friend to tell a friend!</h2>
            <p className="lead mb-5">
              Help us spread the word about this amazing event! Share with your friends and invite them to join us.
            </p>
            
            <div className="social-buttons mb-5">
              <Button 
                variant="primary" 
                className="mx-2 mb-3" 
                onClick={() => handleShare('facebook')}
              >
                <i className="bi bi-facebook me-2"></i>
                Share on Facebook
              </Button>
              
              <Button 
                variant="info" 
                className="mx-2 mb-3" 
                onClick={() => handleShare('twitter')}
              >
                <i className="bi bi-twitter me-2"></i>
                Share on Twitter
              </Button>
              
              <Button 
                variant="danger" 
                className="mx-2 mb-3" 
                onClick={() => handleShare('instagram')}
              >
                <i className="bi bi-instagram me-2"></i>
                Share on Instagram
              </Button>
              
              <Button 
                variant="success" 
                className="mx-2 mb-3" 
                onClick={() => handleShare('whatsapp')}
              >
                <i className="bi bi-whatsapp me-2"></i>
                Share on WhatsApp
              </Button>
            </div>
            
            <div className="qr-code-container">
              <h3 className="h4 mb-3">Scan to Register</h3>
              <div className="bg-white p-4 d-inline-block shadow-sm rounded">
                <QRCodeSVG 
                  value={window.location.origin + `/event/${event?.id || 'youth-bootcamp'}`}
                  size={180}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"H"}
                  includeMargin={true}
                />
              </div>
              <p className="mt-2 text-muted small">Scan with your phone camera to register</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SocialSharing;